export default __webpack_public_path__ + "static/Chevrolet Niva-166489d34ecc492e45697aa7f0adbb8a.jpg";